export class LocalDbConsts {
  static readonly dbName = 'Approvals-LocalDb';
  static readonly dbVersion: number = undefined; // Set to undefined to use the latest version
  static readonly localDbReadWriteTransaction = 'rw';
}
